import gql from "graphql-tag";

export const USER_SIGNIN = gql`
  mutation USERLOGIN(
    $userName: String!
    $password: String!
    $remember_me: Boolean = false
    $role: String = "Admin"
  ) {
    signIn(
      login: $userName
      password: $password
      remember_me: $remember_me
      role: $role
    ) {
      token
      username
      refresh_token
    }
  }
`;
export const USER_SIGNUP = gql`
  mutation USERREGISTER(
    $userName: String!
    $emailAddress: String!
    $password: String!
  ) {
    signUp(username: $userName, email: $emailAddress, password: $password) {
      token
      username
      refresh_token
    }
  }
`;
export const REFRESH_TOKEN_MUTATION = gql`
  mutation REFRESHTOKENMUTATION($refresh_token: String!) {
    refreshToken(refresh_token: $refreshToken) {
      token
      refresh_token
    }
  }
`;
